<template>
<div style="width: 100%">
	<v-subheader>{{$t('templates.doc_templates')}}</v-subheader>
	<UploadFile
		:options="options"
		@progress-update="progressUpdate"
		@file-size-error="fileSizeError"
	/>
	<v-subheader>{{$t('templates.templates')}}</v-subheader>
	<v-card style="width: 100%">
		<v-data-table
			:headers="headers"
			:items="$store.state.templates.list"
			hide-actions
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.type }}</td>
				<td>{{ props.item.template_name }}</td>
				<td>
					<v-btn fab dark small color="indigo lighten-2" :to="'/templates/' + props.item.id">
						<v-icon dark>edit</v-icon>
					</v-btn>
					<v-btn fab dark small color="error lighten-2" @click="dialog = true, removeId = props.item.id">
						<v-icon dark>delete</v-icon>
					</v-btn>
				</td>
			</template>
		</v-data-table>
	</v-card>
	<v-dialog
		v-model="dialog"
		persistent
		max-width="290"
	>
		<v-card>
			<v-card-title class="headline">{{$t('templates.you_sure')}}</v-card-title>
			<v-card-text>
				{{$t('common.delete')}}
				<span class="font-weight-bold">
					{{$t('templates.template')}} #{{ removeId }}
				</span>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="grey"
					flat="flat"
					@click="dialog = false"
				>
					{{$t('common.cancel')}}
				</v-btn>
				<v-btn
					color="error"
					@click="deleteTemplate(removeId), dialog = false"
				>
					{{$t('common.delete')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import UploadFile from '../components/UploadFile'
const { mapActions } = createNamespacedHelpers('templates')
import { HEADERS_TABLE_DOC_TEMPLATES } from '../constants'
import { localeHeadersWorkers } from '../utils/helpers'

export default {
	data(vm) {
		return {
			removeId: 0,
			dialog: false,
			options: {
				button: {
					slot: 'activator',
					fab: true,
					color: 'primary'
				},
				icon: 'attach_file',
				className: 'btn-solid',
				tooltip: vm.$t('templates.select_template'),
				url: Vue.http.options.root + '/templates/upload',
				accept:
				'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			},
			headers: localeHeadersWorkers(HEADERS_TABLE_DOC_TEMPLATES, vm.$t)
		}
	},
	methods: {
		...mapActions(['fetch', 'deleteTemplate']),
			fileSizeError(fileNames) {
			console.error('Files blow are oversized: ', ...fileNames)
		},
		progressUpdate(fileInfoList) {
			console.log('upload speed（kb/s）：', fileInfoList[0].uploadSpeed)
			if (fileInfoList[0].type === 'success') {
				// do something
				console.log('success')
				let response = JSON.parse(fileInfoList[0].response)
				let id = response.id

				this.$router.push('templates/' + id)
			}
		}
	},
	created() {
		this.fetch()
	},
	getters: {},
	components: {
		UploadFile
	}
}
</script>

<style scoped>
.btn-solid {
	opacity: 0;
}
</style>
